import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://api.helm.thehybridconsultant.net';

const styles = {
  wrap: { minHeight: '100vh', background: 'var(--bg)', display: 'flex' },
  sidebar: { width: '220px', borderRight: '1px solid var(--border)', padding: '24px 16px', display: 'flex', flexDirection: 'column' },
  sidebarLogo: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '32px', padding: '0 8px' },
  logoIcon: { width: '28px', height: '28px', background: 'var(--accent)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' },
  logoText: { fontSize: '15px', fontWeight: '600' },
  navItem: { display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', borderRadius: 'var(--radius)', color: 'var(--text-muted)', fontSize: '13px', cursor: 'pointer', transition: 'all 0.15s', marginBottom: '2px' },
  navItemActive: { background: 'var(--accent-dim)', color: 'var(--accent)' },
  navSpacer: { flex: 1 },
  userBar: { padding: '12px', borderRadius: 'var(--radius)', background: 'var(--bg-card)', border: '1px solid var(--border)' },
  userName: { fontSize: '13px', fontWeight: '500', marginBottom: '2px' },
  userEmail: { fontSize: '11px', color: 'var(--text-muted)' },
  logoutBtn: { marginTop: '8px', background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '12px', padding: '0', cursor: 'pointer' },
  main: { flex: 1, padding: '32px', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '28px' },
  title: { fontSize: '20px', fontWeight: '600', letterSpacing: '-0.3px' },
  subtitle: { fontSize: '13px', color: 'var(--text-muted)', marginTop: '4px' },
  connectBtn: { background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 'var(--radius)', padding: '9px 16px', fontSize: '13px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' },
  card: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '20px', transition: 'border-color 0.15s', cursor: 'pointer' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' },
  orgName: { fontSize: '15px', fontWeight: '500' },
  orgType: { fontSize: '11px', padding: '2px 8px', borderRadius: '20px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' },
  orgTypeProd: { background: 'rgba(52,211,153,0.1)', color: 'var(--success)' },
  orgTypeSandbox: { background: 'rgba(251,191,36,0.12)', color: 'var(--warning)' },
  orgUrl: { fontSize: '12px', color: 'var(--text-muted)', fontFamily: 'var(--mono)', marginBottom: '16px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  cardFooter: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  lastUsed: { fontSize: '11px', color: 'var(--text-muted)' },
  deleteBtn: { background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '12px', padding: '4px 8px', borderRadius: '4px', transition: 'all 0.15s' },
  empty: { textAlign: 'center', padding: '80px 24px', color: 'var(--text-muted)' },
  emptyIcon: { fontSize: '40px', marginBottom: '16px' },
  emptyTitle: { fontSize: '16px', fontWeight: '500', color: 'var(--text)', marginBottom: '8px' },
  emptyText: { fontSize: '13px', lineHeight: '1.6', marginBottom: '24px' },
  modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: '24px' },
  modalCard: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '32px', width: '100%', maxWidth: '420px' },
  modalTitle: { fontSize: '17px', fontWeight: '600', marginBottom: '8px' },
  modalSub: { fontSize: '13px', color: 'var(--text-muted)', marginBottom: '24px', lineHeight: '1.5' },
  optionRow: { display: 'flex', gap: '12px', marginBottom: '24px' },
  option: { flex: 1, padding: '14px', border: '1px solid var(--border)', borderRadius: 'var(--radius)', cursor: 'pointer', transition: 'all 0.15s', textAlign: 'center' },
  optionActive: { borderColor: 'var(--accent)', background: 'var(--accent-dim)' },
  optionLabel: { fontSize: '13px', fontWeight: '500', marginBottom: '2px' },
  optionSub: { fontSize: '11px', color: 'var(--text-muted)' },
  modalBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  cancelBtn: { background: 'none', border: '1px solid var(--border)', color: 'var(--text-muted)', borderRadius: 'var(--radius)', padding: '8px 16px', fontSize: '13px' },
  proceedBtn: { background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 'var(--radius)', padding: '8px 16px', fontSize: '13px', fontWeight: '500' },
};

export default function Orgs() {
  const { user, token, logout } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [sandbox, setSandbox] = useState(false);

  const headers = { Authorization: `Bearer ${token}` };

  const fetchOrgs = async () => {
    try {
      const { data } = await axios.get(`${API}/orgs`, { headers });
      setOrgs(data);
    } catch (err) {
      if (err.response?.status === 401) logout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrgs();
    const params = new URLSearchParams(window.location.search);
    if (params.get('connected')) { fetchOrgs(); window.history.replaceState({}, '', '/orgs'); }
  }, []);

  const connectOrg = async () => {
    try {
      const { data } = await axios.get(`${API}/orgs/connect?sandbox=${sandbox}`, { headers });
      window.location.href = data.url;
    } catch { alert('Failed to initiate connection'); }
  };

  const deleteOrg = async (id) => {
    if (!window.confirm('Disconnect this org?')) return;
    await axios.delete(`${API}/orgs/${id}`, { headers });
    setOrgs(orgs.filter(o => o.id !== id));
  };

  const formatDate = (d) => new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

  return (
    <div style={styles.wrap}>
      <div style={styles.sidebar}>
        <div style={styles.sidebarLogo}>
          <div style={styles.logoIcon}>⛵</div>
          <span style={styles.logoText}>Helm</span>
        </div>
        <div style={{ ...styles.navItem, ...styles.navItemActive }}>🏢 Orgs</div>
        <div style={styles.navItem}>🔐 Access</div>
        <div style={styles.navItem}>🚀 Deploy</div>
        <div style={styles.navItem}>📊 Dashboard</div>
        <div style={styles.navSpacer} />
        <div style={styles.userBar}>
          <div style={styles.userName}>{user?.name || 'User'}</div>
          <div style={styles.userEmail}>{user?.email}</div>
          <button style={styles.logoutBtn} onClick={logout}>Sign out</button>
        </div>
      </div>

      <div style={styles.main}>
        <div style={styles.header}>
          <div>
            <div style={styles.title}>Connected Orgs</div>
            <div style={styles.subtitle}>{orgs.length} org{orgs.length !== 1 ? 's' : ''} connected</div>
          </div>
          <button style={styles.connectBtn} onClick={() => setShowModal(true)}>+ Connect Org</button>
        </div>

        {loading ? (
          <div style={{ color: 'var(--text-muted)', fontSize: '13px' }}>Loading...</div>
        ) : orgs.length === 0 ? (
          <div style={styles.empty}>
            <div style={styles.emptyIcon}>⛵</div>
            <div style={styles.emptyTitle}>No orgs connected yet</div>
            <div style={styles.emptyText}>Connect your first Salesforce org to get started. You can connect production orgs and sandboxes.</div>
            <button style={styles.connectBtn} onClick={() => setShowModal(true)}>+ Connect your first org</button>
          </div>
        ) : (
          <div style={styles.grid}>
            {orgs.map(org => (
              <div key={org.id} style={styles.card}>
                <div style={styles.cardHeader}>
                  <div style={styles.orgName}>{org.name}</div>
                  <span style={{ ...styles.orgType, ...(org.org_type === 'sandbox' ? styles.orgTypeSandbox : styles.orgTypeProd) }}>
                    {org.org_type}
                  </span>
                </div>
                <div style={styles.orgUrl}>{org.instance_url}</div>
                <div style={styles.cardFooter}>
                  <span style={styles.lastUsed}>Connected {formatDate(org.connected_at)}</span>
                  <button style={styles.deleteBtn} onClick={() => deleteOrg(org.id)}>Disconnect</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div style={styles.modal} onClick={() => setShowModal(false)}>
          <div style={styles.modalCard} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitle}>Connect a Salesforce Org</div>
            <div style={styles.modalSub}>Choose the type of org you want to connect. You will be redirected to Salesforce to authorise.</div>
            <div style={styles.optionRow}>
              <div style={{ ...styles.option, ...(!sandbox ? styles.optionActive : {}) }} onClick={() => setSandbox(false)}>
                <div style={styles.optionLabel}>Production</div>
                <div style={styles.optionSub}>login.salesforce.com</div>
              </div>
              <div style={{ ...styles.option, ...(sandbox ? styles.optionActive : {}) }} onClick={() => setSandbox(true)}>
                <div style={styles.optionLabel}>Sandbox</div>
                <div style={styles.optionSub}>test.salesforce.com</div>
              </div>
            </div>
            <div style={styles.modalBtns}>
              <button style={styles.cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
              <button style={styles.proceedBtn} onClick={connectOrg}>Connect with Salesforce</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
